import { withStyles, Button } from "@material-ui/core";
import DateRange from "@material-ui/icons/DateRange";

const styles = (theme) => ({
  wrapper: {
    height: 34,
    border: `1px solid ${theme.iconColor}`,
    display: "flex",
    alignItems: "center",
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 12,
    cursor: "pointer",
    color : theme.TextColor,
    "&:focus": {
      background: theme.AppBGColor,
    },
  },
  dateIcon: {
    marginLeft: 8,
  },
});
const DateRangeInputBox = ({ classes, startDate, endDate, onClick }) => (
  <Button disableRipple className={classes.wrapper} onClick={onClick}>
    <span>{`${startDate} - ${endDate}`}</span>
    <DateRange className={classes.dateIcon} />
  </Button>
);

export default withStyles(styles)(DateRangeInputBox);
